"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTagArray = exports.TextSize = exports.TextSizeArray = void 0;
var TextSizeArray = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'inherit'];
exports.TextSizeArray = TextSizeArray;
var TextSize = {
  xxs: '11px',
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  inherit: 'inherit'
};
exports.TextSize = TextSize;
var TextTagArray = ['div', 'p', 'span', 'b', 'strong', 'em', 'label', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
exports.TextTagArray = TextTagArray;